var _path, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "150 150 480 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.44,364.08c89.2.82,135-44.84,135-44.84,22.73-20.46,30.27-48,28-78.53-2.37-31.51-12.77-55.31-40.78-69.91s-62.19-15.53-92-5.18C458.91,171.77,441.71,181.81,423,181c-25.55-1.1-45.81-22.12-58.78-44.17s-21.94-46.91-39.52-65.49c-24.56-26-65.1-35.43-98.62-23s-58.86,42.34-66,78.44c0,0-14.73,48.94,20.23,116.09C253.6,383.6,446.44,364.08,446.44,364.08Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "274.24 214.9 510.11 213.19 516.68 373.55 272.44 371.29 274.24 214.9",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.23,214.9l111.64-90.33a12.82,12.82,0,0,1,16.19.06l108.05,88.56",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.23,214.9l111.64-90.33a12.82,12.82,0,0,1,16.19.06l108.05,88.56"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M272.44,371.29c-.29-.28,18.59-20.9,42.18-46.05s42.94-45.32,43.24-45.05-18.59,20.89-42.18,46.05S272.74,371.56,272.44,371.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.68,373.55c-.3.27-18.69-19.93-41.07-45.11s-40.28-45.82-40-46.09,18.69,19.93,41.07,45.12S517,373.28,516.68,373.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "510.11 213.19 391.66 307.81 274.24 214.9"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "286.11 223.66 285.75 150 492.28 147.55 494.61 225.06 391.65 306.57 286.11 223.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.11,223.66s.67.5,1.94,1.49l5.6,4.36L315,246.18l76.81,60.22h-.26l102.93-81.54-.1.21c-.44-14.78-.91-30.3-1.39-46.08-.31-10.63-.63-21.13-.94-31.43l.26.25-206.53,2.35.16-.16c.08,23.17.15,41.58.19,54.2,0,6.31,0,11.17,0,14.46v3.73c0,.84,0,1.27,0,1.27s0-.42,0-1.25,0-2.08,0-3.71c0-3.29-.07-8.14-.12-14.44-.08-12.64-.2-31.06-.35-54.26v-.17h.16l206.54-2.53h.25v.26c.31,10.29.62,20.79.94,31.42.48,15.79.94,31.3,1.39,46.09v.13l-.1.08-103,81.47-.13.1-.13-.1-76.76-60.42-21.22-16.75L288,225.18C286.74,224.18,286.11,223.66,286.11,223.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.64,184.65c0,.14-31.59.45-70.54.68s-70.55.32-70.55.17,31.58-.45,70.55-.69S459.64,184.5,459.64,184.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.64,205.45c0,.15-31.59.46-70.54.69s-70.55.31-70.55.17,31.58-.45,70.55-.69S459.64,205.31,459.64,205.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.64,229.44c0,.14-31.59.45-70.54.69s-70.55.31-70.55.16,31.58-.45,70.55-.68S459.64,229.29,459.64,229.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.64,253.42c0,.15-30.13.44-67.3.67s-67.3.29-67.31.15,30.13-.44,67.31-.67S459.64,253.28,459.64,253.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.22,274.47a4.35,4.35,0,0,1-.82.06l-2.38.07-8.72.14-28.79.41c-11.24.19-21.43.25-28.8.26l-8.72,0-2.38,0a5.2,5.2,0,0,1-.82-.05,4.35,4.35,0,0,1,.82-.06l2.38-.06,8.72-.15,28.79-.41c11.24-.19,21.43-.25,28.79-.26l8.73,0,2.38,0A6.47,6.47,0,0,1,433.22,274.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.63,294.71c0,.14-6.73.26-15,.26s-15-.12-15-.26,6.74-.26,15-.26S406.63,294.56,406.63,294.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.15,
    cy: 253.42,
    r: 24.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.66,
    cy: 253.42,
    r: 24.95,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.83,241.81v20.74H469V245h-4.39v-3.23Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.b66084952e89aea4d9cb4a7754280698.svg";
export { ForwardRef as ReactComponent };